export enum UserRole {
  Student = 'student',
  Professor = 'professor',
}

export enum EndGameMode {
  Game = 'game',
  Simulation = 'simulation',
}
